export default {
  drop_files:
    'Ziehen Sie Dateien, die Sie hochladen möchten, in dieses Fenster.',
  browse: 'DURCHSUCHE',
  file_upload: 'Datei hochladen',
  error: 'Die Datei kann nicht geladen werden!',
  error_too_large: 'Die Datei ist zu groß',
}
